import { render, staticRenderFns } from "./MarkdownField.vue?vue&type=template&id=c880e7a6&"
import script from "./MarkdownField.vue?vue&type=script&lang=js&"
export * from "./MarkdownField.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports